<template>
    <div style="background-color: #FAF9F7; padding: 20px 0;">
        <div class="aly-form-container">
            <el-form :model="formData" label-position="top" class="custom-form" :rules="rules" ref="dataForm">
                <!-- Country of Residence -->
                <section class="form-section">
                    <h3 class="section-title">Country of residence</h3>
                    <el-select v-model="formData.countryId" placeholder="Select" style="width: 300px;">
                        <el-option v-for="item in CountryList" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </section>

                <!-- Data Subject Details -->
                <section class="form-section">
                    <h3 class="section-title">DATA SUBJECT DETAILS</h3>
                    <p class="section-desc">
                        Please enter your name and email address in order to process your request and safeguard your
                        data.
                        We will use the data gathered here to process your request and for record-keeping as required
                        under the law.
                        <br><br>
                        You will receive an email to verify your address. Follow the instructions to complete the
                        processing of your request.
                    </p>
                    <el-form-item class="mb-15">
                        <el-input v-model="formData.firstName" placeholder="First Name"></el-input>
                    </el-form-item>
                    <el-form-item prop="lastName" class="mb-15">
                        <el-input v-model="formData.lastName" placeholder="Last Name"></el-input>
                    </el-form-item>
                    <el-form-item prop="email" class="mb-15">
                        <el-input v-model="formData.email" placeholder="Email Address"></el-input>
                    </el-form-item>
                </section>

                <div class="divider-1080"></div>

                <!-- Type of Request -->
                <section class="form-section">
                    <h3 class="section-title">TYPE OF REQUEST</h3>
                    <el-radio-group v-model="formData.type" class="vertical-radio-group">
                        <el-radio :label="1">
                            <span class="radio-label-text">Request to Know</span>
                            <p class="radio-desc">You are requesting a report of your personal information in our
                                systems</p>
                        </el-radio>

                        <el-radio :label="2">
                            <span class="radio-label-text">Transfer</span>
                            <p class="radio-desc">Package up your data and send it to a desired recipient</p>
                        </el-radio>

                        <el-radio :label="3">
                            <span class="radio-label-text">Request to Delete</span>
                            <p class="radio-desc">You are requesting that we delete your personal information in our
                                systems</p>
                        </el-radio>

                        <el-radio :label="4">
                            <span class="radio-label-text">Request to Delete</span>
                            <p class="radio-desc">Ask us to stop processing your data for certain purposes (eg. public
                                interest, legitimate interests, direct marketing)</p>
                        </el-radio>

                        <el-radio :label="5">
                            <span class="radio-label-text">Update Inaccuracies</span>
                            <p class="radio-desc">Update any inaccuracy you've found in our systems</p>
                        </el-radio>
                    </el-radio-group>
                </section>

                <div class="divider-1080"></div>

                <!-- Request Details -->
                <section class="form-section" v-if="formData.type == 5">
                    <h3 class="section-title">REQUEST DETAILS</h3>
                    <el-form-item prop="requestInfo">
                        <el-input type="textarea" style="max-width: 500px;" :rows="4" placeholder="Fill In The Content"
                            v-model="formData.requestInfo">
                        </el-input>
                    </el-form-item>
                </section>

                <!-- Data Subject Relationship -->
                <section class="form-section">
                    <h3 class="section-title">DATA SUBJECT RELATIONSHIP</h3>
                    <p class="input-label">I am a:</p>
                    <el-select v-model="formData.userType" placeholder="Select" style="width: 300px;">
                        <el-option label="EMPLOYEE" :value="0"></el-option>
                        <el-option label="FORMER EMPLOYE" :value="1"></el-option>
                        <el-option label="CUSTOMER" :value="2"></el-option>
                        <el-option label="JOB APPLICANT" :value="3"></el-option>
                    </el-select>
                </section>

                <div class="divider-1080"></div>

                <!-- Additional Information -->
                <section class="form-section">
                    <h3 class="section-title">ADDITIONAL INFORMATION, IF NECESSARY</h3>
                    <el-form-item>
                        <el-input type="textarea" style="max-width: 500px;" :rows="4" placeholder="Fill In The Content"
                            v-model="formData.content">
                        </el-input>
                    </el-form-item>
                </section>

                <!-- Submit Button -->
                <section class="form-section mt-30">
                    <el-button type="primary" class="submit-btn" @click="handleSubmit">SUBMIT REQUEST</el-button>
                </section>

            </el-form>
        </div>
    </div>
</template>

<script>
import { getCountryAddressList, privacySubmit } from '@/api/member';
import { mapState } from "vuex";
export default {
    data() {
        // 自定义校验函数：Request Info
        const validateRequestInfo = (rule, value, callback) => {
            if (this.formData.type == 5 && !value) {
                callback(new Error('Please fill in the request details'));
            } else {
                callback();
            }
        };
        // 自定义校验函数：Content
        const validateContent = (rule, value, callback) => {
            // 当 type 不等于 5 时，Content 必填
            if (this.formData.type != 5 && !value) {
                callback(new Error('Please fill in the additional information'));
            } else {
                callback();
            }
        };

        return {
            formData: {
                countryId: 233,
                firstName: '',
                lastName: '',
                email: '',
                type: 1,
                requestInfo: '',
                userType: 2,
                content: ''
            },
            CountryList: [],
            // 定义规则
            rules: {
                requestInfo: [{ validator: validateRequestInfo, trigger: 'blur' }],
                content: [{ validator: validateContent, trigger: 'blur' }],
                lastName: [{ required: true, message: 'Please fill in your last name', trigger: 'blur' }],
                email: [{ required: true, message: 'Please fill in your email address', trigger: 'blur' }]
            }
        };
    },
    // 监听 type 变化
    watch: {
        'formData.type'() {
            this.$nextTick(() => {
                this.$refs.dataForm.clearValidate(['requestInfo', 'content']);
            });
        }
    },
    activated() {
        this.getCountryList()
    },
    computed: {
    ...mapState({
      user: state => state.user.user
    }),
    userInfo() {
      if (!this.user) return {}; // state.user.user 为空时返回空对象
      try {
        return typeof this.user === 'string' ? JSON.parse(this.user) : this.user;
      } catch (e) {
        return {};
      }
    },
    userEmail() {
      return this.userInfo.email || ''; // 核心判断依据
    },
},
    
    methods: {
        handleSubmit() {
            this.formData.loginEmail = this.userEmail;
            this.$refs.dataForm.validate((valid) => {
                if (valid) {
                    privacySubmit(this.formData).then(res => {
                        if (res.code == 1) {
                            this.$message({
                                message: 'SUCCESS',
                                type: 'success'
                            });
                            window.scrollTo({ top: 0,behavior: "instant"});
                            this.$router.push({
                                path: '/privacy'
                            });
                        }
                    })
                }
            });
        },
        getCountryList() {
            getCountryAddressList().then(res => {
                if (res.code == 1) {
                    this.CountryList = res.data.dataList
                }
            })
        },
    }
};
</script>

<style scoped>
.el-input {
    border-color: #dcdfe6;
}

.el-select-dropdown__item.selected {
    color: #333;
}

::v-deep .el-select .el-input__inner:focus {
    border-color: #dcdfe6 !important;
}

::v-deep .el-input.is-focus .el-input__inner {
    border-color: #dcdfe6;
}

/* 容器居中及宽度控制 */
.aly-form-container {
    width: 1080px;
    margin: 0px auto;

    color: #333;
    padding: 20px 0;
}

.aly-form-container div,
div,
h3,
p {
    font-family: "NotoSerif", serif;
}

.custom-form {
    padding: 0 20px;
}

/* 标题样式 */
.section-title {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: 1px;
    margin-bottom: 15px;
    text-transform: uppercase;
}

.section-desc {
    font-size: 16px;
    ;
    color: #666;
    line-height: 1.6;
    margin-bottom: 20px;
    max-width: 800px;
}

.input-label {
    font-size: 16px;
    margin-bottom: 15px;
}

/* 分割线宽度 1080px */
.divider-1080 {
    width: 1080px;
    height: 1px;
    background-color: #e0e0e0;
    margin: 40px 0;
    position: relative;
    left: -20px;
    /* 抵消容器padding确保视觉铺满 */
}

/* 表单组件样式覆盖 */
.form-section {
    margin-bottom: 35px;
}

.mb-15 {
    margin-bottom: 30px;
    width: 500px;
    display: block;
}

.mt-30 {
    margin-top: 30px;
}

/* 单选框列表样式 */
.vertical-radio-group {
    display: flex;
    flex-direction: column;
}

.vertical-radio-group .el-radio {
    margin-bottom: 20px;
    display: flex;
    align-items: flex-start;
}

.radio-label-text {
    font-weight: bold;
    font-size: 13px;
    color: #333;
}

.radio-desc {
    font-size: 16px;
    ;
    color: #888;
    margin: 4px 0 0 0;
    white-space: normal;
}

/* 输入框样式微调 */
::v-deep .el-input__inner,
::v-deep .el-textarea__inner {
    border-radius: 2px;
    border: 1px solid #dcdfe6;
    font-family: "NotoSerif", serif;
}

/* 提交按钮样式 */
.submit-btn {
    width: 260px;
    background-color: #5a4a42;
    /* 设计图棕色 */
    color: #fff;
    height: 55px;
    border: none;
    font-family: "NotoSerif", serif;
    font-size: 16px;
    letter-spacing: 1px;
    text-transform: uppercase;
    cursor: pointer;
    transition: opacity 0.3s;
}

.submit-btn:hover {
    opacity: 0.9;
}

/* 调整 Radio 的选中颜色为深色以匹配原图 */
::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #444;
    background: #444;
}

::v-deep .el-radio__input.is-checked+.el-radio__label {
    color: #333;
}
@media (max-width: 768px) {
    .aly-form-container,.section-desc,.el-input__inner{
       width: 95% !important;
       max-width: 96%;
    }
    .mb-15{
        width: 95% !important;
    }
    .section-title,p,.radio-label-text{
        font-size: 3rem !important;
    } 
    .submit-btn{
        width: auto;
        height: auto;
    }
}
</style>